
import { Component, Vue } from "vue-property-decorator";
import NameAndCedula from "@/components/person/NameAndCedula.vue";
import ValidationRequisitos from "@/components/ValidationRequisitos.vue";
import ValidationService from "@/services/ValidationService";
import User from "../models/User";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import { Action, Getter } from "vuex-class";
import { AxiosResponse } from "axios";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import RequisitoBeneficio, {
  Requisito,
  ParametrosValidacionRequisitosBeneficio,
} from "@/models/RequisitoBeneficio";
import TipoRequisitoEnum from "@/enums/TipoRequisitoEnum";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import Swal from "sweetalert2";
import AfiliadoService from "@/services/AfiliadoService";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import Presolicitud from "@/models/Presolicitud";

@Component({
  components: {
    NameAndCedula,
    ValidationRequisitos,
  },
})
export default class Cesantia extends Vue {
  @Getter("user") user: User;
  @Action("setValidacionCertificacionTssAction")
  setValidacionCertificacionTssAction;
  public loading: boolean = false;
  public showCommunicationError: boolean = false;
  public validationService = new ValidationService();
  public afiliadoService = new AfiliadoService();
  public validacionCertificacionTss: ValidacionCertificacionTss = null;
  public requisitosBeneficio: RequisitoBeneficio = null;
  public aplicaTramiteYCumpleRequisitos: boolean = false;
  public showValidationMessage: boolean = false;
  public TipoBeneficioEnum: TipoBeneficioEnum;
  public showPage: boolean = false;
  public tableFields: Array<{
    key: string;
    label: string;
    sortable: boolean;
    formatter?: (value: any, key: any, item: any) => any;
  }> = [
    { key: "idRNC", label: "RNC", sortable: false },
    { key: "razonSocial", label: "Empleador", sortable: false },
  ];

  created() {
    if (this.user.cedula && this.user.esAfiInactivo) {
      this.$router.push("/");
    }
    this.showPage = true;
  }

  // public obtenerPresolicitudEnProceso(): Promise<Presolicitud> {
  //     return new Promise((resolve, reject) => {
  //         this.afiliadoService
  //             .getPresolicitud(
  //                 new ParametrosObtencionPresolicitud(
  //                     null,
  //                     this.$store.state.user.cedula,
  //                     null,
  //                     null
  //                 )
  //             )
  //             .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
  //                 if (
  //                     response.data.solicitudes &&
  //                     response.data.solicitudes.length > 0
  //                 ) {
  //                     resolve(
  //                         response.data.solicitudes.find(
  //                             (x) =>
  //                                 (x.tipoBeneficio ===
  //                                 TipoBeneficioEnum.IngresoTardio.toString()) &&
  //                                 (!x.solCancelada) &&
  //                                 (!x.docFirmado)
  //                         )
  //                     );
  //                 } else {
  //                     resolve(null);
  //                 }
  //             })
  //             .catch((err) => {
  //                 reject();
  //             });
  //     });
  // }

  // public async validar() {
  //     this.loading = true;
  //    // const presolicitudEnProceso = await this.obtenerPresolicitudEnProceso();
  //     const presolicitudEnProceso = null;
  //     if (!presolicitudEnProceso) {
  //         Swal.fire({
  //             text:
  //                 "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios.",
  //             icon: "info",
  //             timerProgressBar: true,
  //             onBeforeOpen: () => {
  //                 Swal.showLoading();
  //             },
  //             allowOutsideClick: false,
  //         });
  //         this.showCommunicationError = false;
  //         this.requisitosBeneficio = await this.validarRequisitosBeneficio();
  //         this.aplicaTramiteYCumpleRequisitos =
  //             this.requisitosBeneficio.aplicaTramite &&
  //             this.requisitosBeneficio.requisitos.every(
  //                 (x) => x.cumpleRequisito
  //             );

  //         //Ahora siempre validar la TSS
  //         // this.validacionCertificacionTss = await this.validarIngresoTardio(this.requisitosBeneficio.secuencia);
  //         // if (this.aplicaTramiteYCumpleRequisitos
  //         //     && this.validacionCertificacionTss.aplicaTramite) {
  //         //         this.$router.push("/registro-ingreso-tardio");
  //         //     }
  //         this.showValidationMessage = true;
  //         Swal.close();
  //     } else {
  //         Swal.fire({
  //             text: "Ya tienes una solicitud del beneficio de Cesantía en proceso.",
  //             confirmButtonText: "Ir a mi solicitud",
  //             icon: "info",
  //             onClose: () => {
  //                 this.$router.push({
  //                     path: "/registro-cesantia",
  //                     query: {
  //                         numeroSolicitud: presolicitudEnProceso.numeroSolicitud.toString(),
  //                     },
  //                 });
  //             },
  //         });
  //     }
  //     this.loading = false;
  // }

  // public validarRequisitosBeneficio(): Promise<RequisitoBeneficio> {
  //     return new Promise((resolve, reject) => {
  //         const parametrosValidacionRequisitosBeneficio = new ParametrosValidacionRequisitosBeneficio(
  //             null,
  //             this.user.codCuenta,
  //             TipoRequisitoEnum.Validacion,
  //             TipoBeneficioEnum.Cesantia
  //         );
  //         this.validationService
  //             .validarRequisitosBeneficios(
  //                 parametrosValidacionRequisitosBeneficio
  //             )
  //             .then(
  //                 (
  //                     response: AxiosResponse<
  //                         ServiceResponseEntity<RequisitoBeneficio>
  //                     >
  //                 ) => {
  //                     // TODO: REMOVER
  //                     // response.data.entity.requisitos.forEach((x) => {
  //                     //     x.cumpleRequisito = true;
  //                     // });
  //                     resolve(response.data.entity);
  //                 }
  //             )
  //             .catch(() => {
  //                 Swal.close();
  //                 this.showCommunicationError = true;
  //                 this.loading = false;
  //                 reject();
  //             });
  //     });
  // }

  public validateVejezAnticipada(
    secuencia: string
  ): Promise<ValidacionCertificacionTss> {
    return new Promise((resolve, reject) => {
      this.validationService
        .validateVejezAnticipada(secuencia)
        .then(
          (
            response: AxiosResponse<
              ServiceResponseEntity<ValidacionCertificacionTss>
            >
          ) => {
            if (response.data.respCode === 200) {
              if (response.data.entity.aplicaTramite) {
                this.setValidacionCertificacionTssAction(response.data.entity);
              }
              Swal.close();
              this.loading = false;
              resolve(response.data.entity);
            } else {
              Swal.close();
              this.showCommunicationError = true;
              this.loading = false;
              reject();
            }
          }
        )
        .catch(() => {
          Swal.close();
          this.showCommunicationError = true;
          this.loading = false;
          reject();
        });
    });
  }

  public navigateToSolicitudes(): void {
    this.$router.push("/home");
  }

  public async ValidarCertificacionTss(
    secuencia,
    aplicaTramiteYCumpleRequisitos
  ) {
    //this.showValidationMessage = true;
    Swal.fire({
      text:
        "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios.",
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });

    if (aplicaTramiteYCumpleRequisitos) {
      this.$router.push("/registro-vejez-anticipada");
    } else {
      this.showValidationMessage = true;
      Swal.close();
    }
  }
}
